import type { Translations } from '../types'
import { messages as itITMessages } from './it-IT/messages'

export const locale = 'it-IT' as const

export const messages: Translations = itITMessages
